<template>
    <div class="type-column-wrapper">
        <span :class="{ urgent: isUrgent }">{{ data }}</span>
    </div>
</template>

<script>
export default {
    name: "TypeColumn",
    props: ["data", "row"],
    computed: {
        isUrgent() {
            return this.row.addData.type == "1";
        }
    }
};
</script>

<style lang="less" scoped>
.type-column-wrapper {
    .urgent {
        color: #e60c0c;
    }
}
</style>
